module.exports = __webpack_public_path__ + "static/pipeline_overview-c8fbcb384a75aabf1d02378c7d806a1a.png";